import { isUndNullEmp } from '../../helpers/main.js';
const currentDateTimeISO = new Date()?.toISOString();

export class Requirement {
    constructor(
        _id = 0,
        _customerId = 0,
        _userId = '',
        _analystId = '',
        _registerDate = currentDateTimeISO,
        _visitDate = currentDateTimeISO,
        _userRegisterDate = currentDateTimeISO,
        _userVisitDate = currentDateTimeISO,
        _authorizedBy = '',
        _contactPerson = '',
        _department = '',
        _statusId = 0,
        _commentary = '',
        _informCreation = false,
        _informCreationUserId = '',
        _informCreationDate = currentDateTimeISO,
        _informCompletion = false,
        _informCompletionDate = currentDateTimeISO,
        _register = '',
    ) {
        this.id = _id;
        this.customerId = _customerId;
        this.userId = _userId;
        this.analystId = _analystId;
        this.registerDate = _registerDate;
        this.visitDate = _visitDate;
        this.userRegisterDate = _userRegisterDate;
        this.userVisitDate = _userVisitDate;
        this.authorizedBy = _authorizedBy;
        this.contactPerson = _contactPerson;
        this.department = _department;
        this.statusId = _statusId;
        this.commentary = _commentary;
        this.informCreation = _informCreation;
        this.informCreationUserId = _informCreationUserId;
        this.informCreationDate = _informCreationDate;
        this.informCompletion = _informCompletion;
        this.informCompletionDate = _informCompletionDate;
        this.register = _register;
    }

    static getClasscustomerId = () => {
        return 'Requirement - class';
    }

    static minMaxLength = (upperCase = false) => {
        if (upperCase) {
            return {
                min: {
                    Id: 0,
                    CustomerId: 0,
                    UserId: 10,
                    AnalystId: 10,
                    RegisterDate: 10,
                    VisitDate: 10,
                    UserRegisterDate: 10,
                    UserVisitDate: 10,
                    AuthorizedBy: 5,
                    ContactPerson: 5,
                    Department: 4,
                    StatusId: 0,
                    Commentary: 2,
                    InformCreation: 1,
                    InformCreationUserId: 10,
                    InformCreationDate: 10,
                    InformCompletion: 1,
                    InformCompletionDate: 10,
                    Register: 10,
                },
                max: {
                    Id: 450,
                    customerId: 450,
                    UserId: 450,
                    AnalystId: 450,
                    RegisterDate: 30,
                    VisitDate: 30,
                    UserRegisterDate: 30,
                    UserVisitDate: 30,
                    AuthorizedBy: 30,
                    ContactPerson: 60,
                    Department: 60,
                    StatusId: 450,
                    Commentary: 1000,
                    InformCreation: 1,
                    InformCreationUserId: 450,
                    InformCreationDate: 30,
                    InformCompletion: 1,
                    InformCompletionDate: 30,
                    Register: 30,
                },
            };
        } else {
            return {
                min: {
                    id: 0,
                    customerId: 0,
                    userId: 10,
                    analystId: 10,
                    registerDate: 10,
                    visitDate: 10,
                    userRegisterDate: 10,
                    userVisitDate: 10,
                    authorizedBy: 5,
                    contactPerson: 5,
                    department: 4,
                    statusId: 0,
                    commentary: 2,
                    informCreation: 1,
                    informCreationUserId: 10,
                    informCreationDate: 10,
                    informCompletion: 1,
                    informCompletionDate: 10,
                    register: 10,
                },
                max: {
                    id: 450,
                    customerId: 450,
                    userId: 450,
                    AnalystId: 450,
                    registerDate: 30,
                    visitDate: 30,
                    userRegisterDate: 30,
                    userVisitDate: 30,
                    authorizedBy: 30,
                    contactPerson: 60,
                    department: 60,
                    statusId: 450,
                    commentary: 1000,
                    informCreation: 1,
                    informCreationUserId: 450,
                    informCreationDate: 30,
                    informCompletion: 1,
                    informCompletionDate: 30,
                    register: 30,
                },
            };
        }
    }

    // static userIdFullPath = ({userId = '', subMethod = ''} = {}) => {
    //     let response = getResponse({ type: 0 });
    //     const currentMethod = 'Requirement / userIdFullPath';
    //     try {
    //         if(!isUndNullEmp({data: userId, subMethod: currentMethod})?.result){
    //             userId = userId.replace('~/Images/UserIds/Requirement/', `${settings?.backend?.urls?.imageUserIds}${settings?.backend?.urls?.paymentInformations}/`);
    //             response.result = `${settings?.backend?.urls?.api}${userId}`
    //         } else {
    //             response.result = `${settings?.backend?.urls?.api}${settings?.images?.noImage}`;
    //         }
    //     } catch (ex) {
    //         response.isSuccess = false;
    //         response.msgType = -1;
    //         response.msgText = `Method: ${currentMethod}<br/>`;
    //         if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
    //             response.msgText += `Sub method: ${subMethod}<br/>`;
    //         }
    //         response.msgText += `Error: ${ex?.message}<br/>`;
    //     }
    //     return response;
    // }

    static getClass = (obj = {}, upperCase = false) => {
        if (!isUndNullEmp({ data: obj, subMethod: Requirement.getClasscustomerId() })?.result) {
            if (upperCase) {
                return new Requirement(
                    obj.Id,
                    obj.CustomerId,
                    obj.UserId,
                    obj.AnalystId,
                    obj.RegisterDate,
                    obj.VisitDate,
                    obj.UserRegisterDate,
                    obj.UserVisitDate,
                    obj.AuthorizedBy,
                    obj.ContactPerson,
                    obj.Department,
                    obj.StatusId,
                    obj.Commentary,
                    obj.InformCreation,
                    obj.InformCreationUserId,
                    obj.InformCreationDate,
                    obj.InformCompletion,
                    obj.InformCompletionDate,
                    obj.Register,
                );
            } else {
                return new Requirement(
                    obj.id,
                    obj.customerId,
                    obj.userId,
                    obj.analystId,
                    obj.registerDate,
                    obj.visitDate,
                    obj.userRegisterDate,
                    obj.userVisitDate,
                    obj.authorizedBy,
                    obj.contactPerson,
                    obj.department,
                    obj.statusId,
                    obj.commentary,
                    obj.informCreation,
                    obj.informCreationUserId,
                    obj.informCreationDate,
                    obj.informCompletion,
                    obj.informCompletionDate,
                    obj.register,
                );
            }
        } else {
            return new Requirement();
        }
    }
}